var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationPrompts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 88,
    viewBox: "0 0 207 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1147_28753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5079 6.02344H8.70656C7.10391 6.02344 5.80469 7.30696 5.80469 8.88871C5.80469 10.4719 7.10391 11.7554 8.70656 11.7554H88.5079C90.1106 11.7554 91.4098 10.4719 91.4098 8.88871C91.4098 7.30696 90.1106 6.02344 88.5079 6.02344Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80469 20.3506C5.80469 18.2407 7.53696 16.5293 9.67385 16.5293H197.329C199.465 16.5293 201.198 18.2407 201.198 20.3506V58.558H9.67385C7.53696 58.558 5.80469 56.8466 5.80469 54.7367V20.3506Z",
    fill: "#CFDCE3",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.557 24.1719H16.4448C14.8421 24.1719 13.543 25.454 13.543 27.0372C13.543 28.6203 14.8421 29.9024 16.4448 29.9024H190.557C192.16 29.9024 193.459 28.6203 193.459 27.0372C193.459 25.454 192.16 24.1719 190.557 24.1719Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.557 34.6787H16.4448C14.8421 34.6787 13.543 35.9608 13.543 37.544C13.543 39.1271 14.8421 40.4093 16.4448 40.4093H190.557C192.16 40.4093 193.459 39.1271 193.459 37.544C193.459 35.9608 192.16 34.6787 190.557 34.6787Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.062 45.1865H16.4448C14.8421 45.1865 13.543 46.4687 13.543 48.0518C13.543 49.6349 14.8421 50.9171 16.4448 50.9171H146.062C147.665 50.9171 148.964 49.6349 148.964 48.0518C148.964 46.4687 147.665 45.1865 146.062 45.1865Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5079 63.334H8.70656C7.10391 63.334 5.80469 64.6175 5.80469 66.2007C5.80469 67.7824 7.10391 69.0659 8.70656 69.0659H88.5079C90.1106 69.0659 91.4098 67.7824 91.4098 66.2007C91.4098 64.6175 90.1106 63.334 88.5079 63.334Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9613 73.8408H8.70656C7.10391 73.8408 5.80469 75.1244 5.80469 76.7075C5.80469 78.2893 7.10391 79.5728 8.70656 79.5728H15.9613C17.5639 79.5728 18.8632 78.2893 18.8632 76.7075C18.8632 75.1244 17.5639 73.8408 15.9613 73.8408Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8557 73.8408H26.6011C24.9985 73.8408 23.6992 75.1244 23.6992 76.7075C23.6992 78.2893 24.9985 79.5728 26.6011 79.5728H33.8557C35.4583 79.5728 36.7576 78.2893 36.7576 76.7075C36.7576 75.1244 35.4583 73.8408 33.8557 73.8408Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7502 73.8408H44.4955C42.8928 73.8408 41.5938 75.1244 41.5938 76.7075C41.5938 78.2893 42.8928 79.5728 44.4955 79.5728H51.7502C53.3529 79.5728 54.6521 78.2893 54.6521 76.7075C54.6521 75.1244 53.3529 73.8408 51.7502 73.8408Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.444 0.989258H5.55773C2.87229 0.989258 0.695312 3.17306 0.695312 5.86692V79.7286C0.695312 82.4225 2.87229 84.6063 5.55773 84.6063H201.444C204.129 84.6063 206.306 82.4225 206.306 79.7286V5.86692C206.306 3.17306 204.129 0.989258 201.444 0.989258Z",
    stroke: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1147_28753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 87,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationPrompts);
export default __webpack_public_path__ + "static/media/conversationPrompts.fe126fb7691d3e527f582e6ff7c9aded.svg";
export { ForwardRef as ReactComponent };